import { colors } from '../../colors';
var para = {
  messageColor: colors.petsuitesPurple
};
export default para;